export const getInputModeFromFrequency = (freq) => {
  if (!freq) return "1";
  const f = String(freq).toLowerCase();
  if (f.includes("month")) return "12";
  if (f.includes("quarter")) return "4";
  if (f.includes("half")) return "6";
  return "1";
};

/**
 * Number of premium installments per year for the supplied frequency.
 * Used to scale yearly fallback amounts when no dynamic premium is
 * available (Yearly → 1, Half-Yearly → 2, Quarterly → 4, Monthly → 12).
 */
export const getFrequencyDivisor = (freq) => {
  const f = String(freq || "Yearly").toLowerCase();
  if (f.includes("month")) return 12;
  if (f.includes("quarter")) return 4;
  if (f.includes("half")) return 2;
  return 1;
};

export const getDisplayFrequencyLabel = (
  frequency,
  { lowercase = false } = {},
) => {
  const normalized = String(frequency || "Yearly").trim().toLowerCase();
  let label = "Year";
  if (normalized === "monthly") label = "Month";
  else if (normalized === "quarterly" || normalized === "quaterly")
    label = "Quarter";
  else if (normalized === "half-yearly" || normalized === "half yearly")
    label = "Half Year";
  return lowercase ? label.toLowerCase() : label;
};
